import solana from "../../assets/sponsor-logo/solana.png";
import filecoin from "../../assets/sponsor-logo/filecoin.png";
import replit from "../../assets/sponsor-logo/replit.png";
import gra from "../../assets/sponsor-logo/gra.png";
import wellfit from "../../assets/sponsor-logo/wellfit.png";

export const silver = [
  {
    img: solana,
    link: "https://solana.com/",
    twitter: "https://twitter.com/solana",
    width: "80%",
    height: "",
  },
  {
    img: filecoin,
    link: "https://filecoin.io/",
    twitter: "https://twitter.com/Filecoin",
    width: "80%",
    height: "",
  },
  {
    img: replit,
    link: "https://replit.com/",
    twitter: "https://twitter.com/replit",
    width: "80%",
    height: "",
  },
  {
    img: gra,
    link: "https://gracoustics.com/",
    fb: "https://www.facebook.com/gracousticskochi/",
    width: "",
    height: "75px",
  },
  {
    img: wellfit,
    link: "https://www.wellfitindia.com/",
    insta: "https://instagram.com/wellfitindia?igshid=YmMyMTA2M2Y=",
    width: "",
    height: "75px",
  },
];
